import { IAppState } from 'src/store/types';

export const getTranslationData = (state: IAppState) => state.requests.translations.data;
export const getTranslationLoading = (state: IAppState) => state.requests.translations.isLoading;
export const getTranslationErrors = (state: IAppState) => state.requests.translations.error;
